<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <el-row>
        <el-col
          :span="24"
          class="scene_top"
          v-lazy:background-image="classicCaseImg.picture1"
        >
          <div class="scene_topContent">
            <h1>经典案例</h1>
            <p>CLASSIC CASE</p>
          </div>
        </el-col>
      </el-row>
      <!-- 合作伙伴 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space cooperative_partner">
            <div class="title">
              <h3>合作伙伴</h3>
              <i class="lineTitel"></i>
            </div>
            <div class="tips">
              <span>12</span
              >年用心专业服务<span>40</span>多家百强开发商，与<span>300</span>余家开发商建立良好合作关系<br />与<span
                >绿地，正荣，恒大，碧桂园，中粮，中建，福晟
              </span>
              等众多知名企业达成战略合作
            </div>
            <el-row>
              <el-col :span="24">
                <div class="partnerContent">
                  <ul>
                    <li>
                      <img v-lazy="classicCaseImg.picture2" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture3" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture4" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture5" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture6" />
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <img v-lazy="classicCaseImg.picture7" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture8" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture9" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture10" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture11" />
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <img v-lazy="classicCaseImg.picture12" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture13" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture14" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture15" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture16" />
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <img v-lazy="classicCaseImg.picture17" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture18" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture19" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture20" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture21" />
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <img v-lazy="classicCaseImg.picture22" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture23" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture24" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture25" />
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture26" />
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 合作伙伴 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space cooperative_partner">
            <div class="title">
              <h3>项目案例</h3>
              <i class="lineTitel"></i>
            </div>
            <el-row>
              <el-col :span="24">
                <div class="classicCaseContent">
                  <ul>
                    <li>
                      <img v-lazy="classicCaseImg.picture27" />
                      <div>
                        <p>长沙爱家·当代镜</p>
                        <p>蓝海购首个开发项目<br />梅溪湖绿色健康科技住区</p>
                        <p>服务类型：自开发项目</p>
                        <p>
                          项目地址：长沙市高新区东方红路<br />和文轩路交汇处
                        </p>
                      </div>
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture28" />
                      <div>
                        <p>花桥绿地未来中心</p>
                        <p>17万方都市综合体<br />花桥唯一大型生活购物中心</p>
                        <p>服务类型：全案代理</p>
                        <p>项目地址：苏州市昆山市绿地大道<br />绿地未来中心</p>
                      </div>
                    </li>
                  </ul>
                  <i></i>
                  <ul>
                    <li>
                      <img v-lazy="classicCaseImg.picture29" />
                      <div>
                        <p>杭州资辉壹方汇</p>
                        <p>杭州唯一双地铁上盖综合体<br />逆势热销</p>
                        <p>服务类型：现场总代</p>
                        <p>
                          项目地址：杭州市拱墅区莫干山路<br />与萍水街交叉口
                        </p>
                      </div>
                    </li>
                    <li>
                      <img v-lazy="classicCaseImg.picture30" />
                      <div>
                        <p>上海禹洲商业广场</p>
                        <p>上海公寓销售TOP10<br />浦东向南、劲爆热销</p>
                        <p>服务类型：现场总代</p>
                        <p>项目地址：浦东新区金港路299号</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style>
.el-carousel__container {
  height: 625px !important;
}

.el-carousel__button {
  border-radius: 50%;
  width: 10px !important;
  height: 10px !important;
}

.el-carousel__indicator--horizontal {
  padding: 12px 21px 39px 0 !important;
}
</style>
<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  .scene_top {
    // background: url(~@/assets/images/BOSClassicCaseBackground.png) no-repeat;
    background-size: 100% 100%;
    height: 593px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      text-align: left;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        padding-bottom: 22px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      p {
        font-size: 20px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
        text-align: center;
      }
    }
  }

  //1 公共样式
  .content_space {
    // background: url(~@/assets/images/bg.png) no-repeat;
    // padding: 49px 261px 56px 260px;
    .title {
      font-size: 30px;
      font-family: MicrosoftYaHeiLight;
      font-weight: bold;
      color: #000000;
      h3 {
        font-size: 30px;
        margin-bottom: 25px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #333333;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 87px;
      }
    }
    .content {
      width: 304px;
      margin: auto;
      font-weight: 400;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        margin: 43px 0 44px 0;
      }
      p {
        font-size: 16px;
        font-family: MicrosoftYaHeiLight;
        line-height: 32px;
        height: 190px;
      }

      .el-button {
        margin-top: 23px;
        border-radius: 25px;
        a {
          text-decoration: none;
          color: #3d3d3d;
        }
      }

      .el-button:hover,
      .el-button:focus {
        background: #e9471a;
      }

      .el-button:hover a,
      .el-button:focus a {
        color: #fff;
      }
    }
  }

  //合作伙伴
  .cooperative_partner {
    background: none;
    padding: 49px 260px 56px 259px;
    .title {
      padding-top: 30px;
      h3 {
        margin-bottom: 0 !important;
      }
      .lineTitel {
        width: 76px;
        height: 5px;
        background: #a7823c;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }
    .tips {
      font-size: 16px;
      margin: 0 auto;
      margin-top: 38px;
      margin-bottom: 75px;
      line-height: 32px;
      span {
        font-size: 20px !important;
        font-weight: bold;
        color: #28449f;
        margin: 0 10px;
      }
    }

    .partnerContent {
      display: flex;
      justify-content: space-between;
      ul li {
        list-style: none;
      }
    }

    .classicCaseContent {
      margin-top: 53px;
      ul {
        display: flex;
        justify-content: space-between;

        li {
          list-style: none;
          display: flex;
          justify-content: space-between;
          img {
            max-width: 402px;
            max-height: 227px;
          }
          div {
            margin-left: 28px;
            text-align: left;
            > p:nth-of-type(1) {
              font-size: 20px;
              font-family: MicrosoftYaHei;
              font-weight: bold;
              color: #27439f;
              margin-bottom: 20px;
            }

            > p:nth-of-type(2) {
              font-size: 16px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #010101;
              line-height: 26px;
            }

            > p:nth-of-type(3) {
              font-size: 16px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #aaa7a7;
              line-height: 26px;
            }

            > p:nth-of-type(4) {
              font-size: 16px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #aaa7a7;
              line-height: 26px;
            }
          }
        }
      }
      i {
        width: 1400px;
        height: 2px;
        background: #dedddd;
        margin: 36px 0 38px 0;
        display: block;
      }
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";
import classicCaseImg1 from "@/assets/images/BOSClassicCaseBackground.png";
import classicCaseImg2 from "@/assets/images/BOSWF.png";
import classicCaseImg3 from "@/assets/images/BOSEvergrande.png";
import classicCaseImg4 from "@/assets/images/BOSLongfor.png";
import classicCaseImg5 from "@/assets/images/BOSGreenland.png";
import classicCaseImg6 from "@/assets/images/BOSWanda.png";
import classicCaseImg7 from "@/assets/images/BOSJiuchuangCapital.png";
import classicCaseImg8 from "@/assets/images/BOSWanKe.png";
import classicCaseImg9 from "@/assets/images/BOSXuhui.png";
import classicCaseImg10 from "@/assets/images/BOSKaisa.png";
import classicCaseImg11 from "@/assets/images/BOSSUNING.png";
import classicCaseImg12 from "@/assets/images/BOSOnlyHunting.png";
import classicCaseImg13 from "@/assets/images/BOSMinmetals.png";
import classicCaseImg14 from "@/assets/images/BOSCSCEC.png";
import classicCaseImg15 from "@/assets/images/BOSCMCREALESTATE.png";
import classicCaseImg16 from "@/assets/images/BOSWangfujing.png";
import classicCaseImg17 from "@/assets/images/BOSLianTrankcs.png";
import classicCaseImg18 from "@/assets/images/BOSSHIMA.png";
import classicCaseImg19 from "@/assets/images/BOSRiseSun.png";
import classicCaseImg20 from "@/assets/images/BOSRadioTelevision.png";
import classicCaseImg21 from "@/assets/images/BOSWalmart.png";
import classicCaseImg22 from "@/assets/images/BOSTsinghua.png";
import classicCaseImg23 from "@/assets/images/BOSXinHuaCapital.png";
import classicCaseImg24 from "@/assets/images/BOSZhonghai.png";
import classicCaseImg25 from "@/assets/images/BOSSyngenetic.png";
import classicCaseImg26 from "@/assets/images/BOSMETRO.png";
import classicCaseImg27 from "@/assets/images/BOSClassicCaseOne.png";
import classicCaseImg28 from "@/assets/images/BOSClassicCaseTwo.png";
import classicCaseImg29 from "@/assets/images/BOSClassicCaseThree.png";
import classicCaseImg30 from "@/assets/images/BOSClassicCaseFour.png";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {
      tabIndex: "3",
      classicCaseImg: {
        picture1: classicCaseImg1,
        picture2: classicCaseImg2,
        picture3: classicCaseImg3,
        picture4: classicCaseImg4,
        picture5: classicCaseImg5,
        picture6: classicCaseImg6,
        picture7: classicCaseImg7,
        picture8: classicCaseImg8,
        picture9: classicCaseImg9,
        picture10: classicCaseImg10,
        picture11: classicCaseImg11,
        picture12: classicCaseImg12,
        picture13: classicCaseImg13,
        picture14: classicCaseImg14,
        picture15: classicCaseImg15,
        picture16: classicCaseImg16,
        picture17: classicCaseImg17,
        picture18: classicCaseImg18,
        picture19: classicCaseImg19,
        picture20: classicCaseImg20,
        picture21: classicCaseImg21,
        picture22: classicCaseImg22,
        picture23: classicCaseImg23,
        picture24: classicCaseImg24,
        picture25: classicCaseImg25,
        picture26: classicCaseImg26,
        picture27: classicCaseImg27,
        picture28: classicCaseImg28,
        picture29: classicCaseImg29,
        picture30: classicCaseImg30,
      },
    };
  },
  methods: {},
  computed: {},
};
</script>